<template>
  <div>
    <div class="container-fluid">
      <div class="row mt17">
        <div class="col-sm-12">
          <stripe-dialog
            :orderId="selectedFee._id"
            :amount="selectedFee.amount"
            :show="showStripeDialog"
            v-on:close="showStripeDialog = false"
            @pay="pay"
            :donappError="error"
            id="donation-fee"
            :loading="loadingStripe"
          />
          <data-table
            title
            ref="table"
            :tableHeaders="tableHeaders"
            :radioFilter="radioFilter"
            :onAction="onAction"
            :rowActions="rowActions"
            :getData="getDonationFees"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DataTable from '@/components/shared/dataTable/DataTable'
import StripeDialog from '@/components/shared/StripeDialog'
import apiService from '@/services/ApiService'
import formatter from '@/mixins/Formatter'
import moment from 'moment'
import { donationFee as donationTable } from '@/components/merchants/tables/settings'

export default {
  name: 'merchant-donation-fee',
  components: {
    DataTable,
    StripeDialog
  },
  mixins: [formatter],
  data() {
    return {
      error: undefined,
      showStripeDialog: false,
      loadingStripe: false,
      selectedFee: {
        _id: '',
        amount: 0
      },
      ...donationTable
    }
  },
  methods: {
    ...mapMutations({
      goTo: 'goTo'
    }),
    getDonationFees: async function(page, filters) {
      return apiService.getDonationFees({
        page: page - 1,
        ...filters,
        filters: JSON.stringify(filters.filters)
      })
    },
    onAction: function(action, row, index) {
      switch (action) {
        case 'pay':
          this.selectedFee = row
          this.orderId = moment(row.dueDate)
            .format("DD, MMM 'YY")
            .toString()
          this.showStripeDialog = true
          if (this.hasStripeSource) this.pay()
          else this.error = this.$i18n.t('messages.payment_not_available')
          break
        case 'details':
          this.goTo({ path: '/merchants/donations/' + row._id })
          break
        default:
          break
      }
    },
    pay: async function() {
      this.loadingStripe = true
      try {
        const {
          data: { error }
        } = await apiService.payDonationFee(this.selectedFee._id, {
          amount: this.selectedFee.amount
        })
        if (error) this.error = error.message
        else {
          this.showStripeDialog = false
          this.selectedFee = {
            _id: '',
            amount: 0
          }
          this.$refs.table.refresh()
        }
      } catch (error) {
        this.error = error.message
      }
      this.loadingStripe = false
    }
  },
  computed: {
    ...mapState({
      hasStripeSource: state => {
        const merchant = state.user.loggedRole.merchant
        if (merchant) return merchant.fees && merchant.fees.stripeDonation ? merchant.fees.stripeDonation.valid : false
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/merchants/DonationFee.vue